import React, { useMemo } from "react";
import styled from "styled-components";
import { useLocalization } from "../../config/hooks";
import { TOAST_LIMIT, TOAST_POSITION, TOAST_TIMEOUT, TOAST_Z_INDEX, } from "../const";
import { ToastContext } from "../toast-context/toast-context";
import Toast from "../toast/toast";
import { ToastContainer } from "./toast-provider-styled";
import { useToastProviderState } from "./use-toast-provider-state";
export const ToastProvider = ({ toastLimit = TOAST_LIMIT, zIndex = TOAST_Z_INDEX, toastTimeout = TOAST_TIMEOUT, position = TOAST_POSITION, children, }) => {
    const { toasts, addToast, removeToast, updateToast } = useToastProviderState({
        toastTimeout,
        position,
    });
    const localization = useLocalization();
    const slicedToasts = useMemo(() => {
        const [vertical, _] = position.split("-");
        const filtered = toasts.filter((toast) => toast.status === "active");
        if (vertical === "top") {
            return filtered.slice(0, toastLimit).reverse();
        }
        else {
            return filtered.slice(0, toastLimit);
        }
    }, [toasts, toastLimit, position]);
    return (React.createElement(ToastContext.Provider, { value: { addToast, removeToast, updateToast } },
        React.createElement("div", { "aria-live": "polite", "aria-atomic": "true" }, !!slicedToasts.length && (React.createElement(ToastContainer, { as: "ol", role: "region", "aria-label": localization.notification.regionLabel(), zIndex: zIndex, position: position }, slicedToasts.map((toast) => {
            if (typeof toast.render === "function") {
                return toast.render(React.createElement(StyledToastListItem, { key: toast.id },
                    React.createElement(Toast, Object.assign({}, toast))));
            }
            return (React.createElement(StyledToastListItem, { key: toast.id },
                React.createElement(Toast, Object.assign({}, toast))));
        })))),
        children));
};
const StyledToastListItem = styled.li `
  display: contents;
`;
export default ToastProvider;
